module.exports = __webpack_public_path__ + "img/car_10.72381182.jpeg";